import GuidedCaptureOptionsStore from '../store/schema/GuidedCaptureOptionsStore';
import getGuidedCaptureOptions from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    EventCaptureOptions,
} from 'owa-outlook-service-options';

export default function getAutoCollectionEnabled(): boolean {
    let optionsStore: GuidedCaptureOptionsStore = getGuidedCaptureOptions();
    let userOptions = getOptionsForFeature<EventCaptureOptions>(OwsOptionsFeatureType.EventCapture);

    return getFallbackValueIfNull(
        optionsStore.autoCollectionEnabled,
        userOptions.autoCollectionEnabled
    );
}
